import axios, { AxiosResponse } from 'axios';

export const getSharedTeamRooms = (): Promise<AxiosResponse> =>
	axios.get(`/snaps/share/team-member`);

export const deleteSharedTeamRoom = (id: string): Promise<AxiosResponse> =>
	axios.delete(`/snaps/shared-to-me/${id}`);

export const loadMoreSharedTeamRooms = (page: number): Promise<AxiosResponse> =>
	axios.get(`/snaps/share/team-member?page=${page}`);
